import { Model } from '@nozbe/watermelondb'
import { field, date, readonly, relation, children } from '@nozbe/watermelondb/decorators'

export default class User extends Model {
    static table = 'users'
    static associations = {
        merchants: { type: 'belongs_to', key: 'merchant_id' },
        user_invitations: { type: 'has_many', foreignKey: 'invited_by_id' },
    } as const

    @field('merchant_id') merchantId!: string
    @field('phone') phone!: string
    @field('name') name!: string | null
    @field('email') email!: string | null
    @field('pin') pin!: string | null
    @field('avatar_url') avatarUrl!: string | null
    @field('role') role!: string
    @field('onboarding_status') onboardingStatus!: string
    @field('approved_by_id') approvedById!: string | null
    @date('approved_at') approvedAt!: Date | null
    @field('invited_by_id') invitedById!: string | null
    @date('last_login_at') lastLoginAt!: Date | null
    @field('is_primary_owner') isPrimaryOwner!: boolean
    @field('is_active') isActive!: boolean
    @field('version') version!: number
    @field('is_synced') isSynced!: boolean
    @field('is_deleted') isDeleted!: boolean
    @readonly @date('created_at') createdAt!: Date
    @readonly @date('updated_at') updatedAt!: Date

    @relation('merchants', 'merchant_id') merchant: any
    @children('user_invitations') sentInvitations: any
}
